module.exports = __webpack_public_path__ + "static/media/payrollApproval.0f14fa69.svg";